import { render, staticRenderFns } from "./EditUserAuth.vue?vue&type=template&id=0db07245&"
import script from "./EditUserAuth.vue?vue&type=script&lang=ts&"
export * from "./EditUserAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports